import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { "element-loading-text": "正在提交数据，请稍后" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, reactive, onMounted, unref } from 'vue';
import { ElMessage } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { GetDeptListApi } from '../../../../apis/systems/systems.api';
import { CreateDeptRelApi, GetDeptPostRelInfoApi, DelDeptRelApi } from '@/apis/ct_categorys_config/categorycfg.api';
import { DeptDetailDto } from '../../../../apis/systems/systems.dto';
import { CreateDeptPostsRelDto } from '@/apis/ct_categorys_config/categorycfg.dto';
import { useDictionary } from '@/store/dictionary.store';


export default /*#__PURE__*/_defineComponent({
  emits: ['save'],
  setup(__props, { expose, emit: $emits }) {



const store = useDictionary();
const deptList = ref<DeptDetailDto[]>([]);

const formSchema = ref<CreateDeptPostsRelDto>({
	cat_config_id: '',
	dept_id: '',
	posts_id_list: [],
});

const state = reactive({
	show: false,
	loading: false,
	isEditor: false,
	relData: {},
});

/* 需要处理加载的数据 */
const load = {
	/* 获取部门列表 */
	getDeptList: async () => {
		const { succeeded, errors, data } = await GetDeptListApi({ search_key: '', mainstay_id: '' });

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			deptList.value = data || [];
		}
	},

	getDeptPostsList: async (rowId: string) => {
		state.loading = true;
		const { succeeded, errors, data } = await GetDeptPostRelInfoApi(rowId);
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			formSchema.value = data;
		}

		state.loading = false;
	},
};

/* 按钮操作 */
const actions = {
	/* 点击保存按钮 */
	onSaveBtnClick: async () => {
		state.loading = true;

		if (state.isEditor) {
			const delInput: any = { id: state.relData['id'], revision: state.relData['revision'] };
			await DelDeptRelApi(delInput);
		}

		CreateDeptRelApi(unref(formSchema))
			.then((res) => {
				const { succeeded, errors } = res;

				if (!succeeded) {
					ElMessage.error(errors);
				} else {
					ElMessage.success('操作成功');

					$emits('save', unref(formSchema));
					state.show = false;
				}
			})
			.finally(() => {
				state.loading = false;
			});
	},
};

const exposeFuncs = {
	showDialog: (configId: string) => {
		unref(formSchema).cat_config_id = configId;

		state.show = true;
		state.isEditor = false;
	},

	editor: (row: any) => {
		load.getDeptPostsList(row.id);

		state.relData = row;
		state.show = true;
		state.isEditor = true;
	},
};

onMounted(() => {
	load.getDeptList();
});

expose({ ...exposeFuncs });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).show) = $event)),
    title: "审批部门配置",
    style: {"width":"520px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: _unref(state).loading,
        onClick: actions.onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_el_button, {
        type: "info",
        disabled: _unref(state).loading,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          size: "small",
          "label-width": "100px",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "部门",
                      prop: "dept_list"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.dept_id,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.dept_id) = $event)),
                          filterable: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deptList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.dept,
                                label: item.dept_desc,
                                value: item.dept
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "职位",
                      prop: "posts_id_list"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.posts_id_list,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.posts_id_list) = $event)),
                          style: {"width":"100%"},
                          "value-key": "code",
                          multiple: "",
                          filterable: "",
                          placeholder: "请选择职位"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getSelectList('ErpDuty'), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})